import { makeStyles } from '@material-ui/core/styles'

export default makeStyles((theme) => ({
  root: {
    '& .MuiTextField-root': {
      margin: theme.spacing(1),
    },
  },
  paper: {
    margin: '20px auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    borderRadius: '20px',
    padding: theme.spacing(2),
    boxShadow: `0 0 5px 2px rgb(0 0 0 / 0.2)`,
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  submit: {
    borderRadius: '20px',
    color: '#fff',
    backgroundColor: '#000',
    '&:hover': {
      background: 'linear-gradient(90deg, #92fe9d 0%, #00C9FF 100%)',
    },
    margin: theme.spacing(3, 0, 2),
  },

  subtitle: {
    textAlign: 'center',
    ...theme.typography.button,
    alignContent: 'center',
    padding: theme.spacing(1),
  },
  image: {
    display: 'flex',
    alignItems: 'center',
  },
}))
